import React, { useState, useEffect } from 'react';
import lessonsData from '../../../data/lessonsData.json';
import LessonCardItem from './LessonCardItem';
import '../../../scss/components/LessonsPage/LessonDescription.scss';

const LessonDescription = ({ moduleName, lessonId, updateLessonTitle }) => {
    const [lessonData, setLessonData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLessonData = async () => {
            setIsLoading(true);
            setError(null);
            try {
                // Найдем модуль по ID
                const moduleIdStr = String(moduleName);
                const lessonIdStr = String(lessonId);

                const foundModule = lessonsData.modules.find(
                    module => String(module.id) === moduleIdStr
                );

                if (foundModule) {
                    const foundLesson = foundModule.lessons.find(
                        lesson => String(lesson.id) === lessonIdStr
                    );

                    if (foundLesson) {
                        setLessonData(foundLesson);

                        // Обновляем заголовок в родительском компоненте
                        if (updateLessonTitle) {
                            updateLessonTitle(foundLesson.title);
                        }
                    } else {
                        // Если урок не найден, используем первый урок в модуле
                        if (foundModule.lessons && foundModule.lessons.length > 0) {
                            const firstLesson = foundModule.lessons[0];
                            console.log('Урок не найден. Используем первый урок в модуле:', firstLesson.title);
                            setLessonData(firstLesson);

                            if (updateLessonTitle) {
                                updateLessonTitle(firstLesson.title);
                            }
                        } else {
                            setError('Урок не найден в выбранном модуле');
                        }
                    }
                } else {
                    console.error('Модуль не найден. Пробуем найти любой доступный модуль...');

                    // Если модуль не найден, проверим первый доступный модуль
                    if (lessonsData.modules && lessonsData.modules.length > 0) {
                        const firstModule = lessonsData.modules[0];
                        console.log('Используем первый модуль:', firstModule.title);

                        if (firstModule.lessons && firstModule.lessons.length > 0) {
                            const firstLesson = firstModule.lessons[0];
                            console.log('Используем первый урок:', firstLesson.title);
                            setLessonData(firstLesson);

                            if (updateLessonTitle) {
                                updateLessonTitle(firstLesson.title);
                            }
                        } else {
                            setError('Уроки не найдены');
                        }
                    } else {
                        setError('Модули не найдены');
                    }
                }
            } catch (error) {
                console.error('Ошибка при загрузке данных урока:', error);
                setError('Ошибка при загрузке данных урока');
            } finally {
                setIsLoading(false);
            }
        };

        fetchLessonData();
    }, [moduleName, lessonId, updateLessonTitle]);

    // Заглушка для данных, если lessonData не найден
    const defaultLessonData = {
        title: error || "Урок не найден",
        description: "Информация об уроке отсутствует. Пожалуйста, вернитесь к списку уроков и выберите другой урок.",
        theme: "Не указана",
        homework: {
            tasks: [],
            criteria: [],
            maxScore: 0
        }
    };

    // Используем данные урока или заглушку
    const displayData = lessonData || defaultLessonData;

    if (isLoading) {
        return <div className="lesson-loading">Загрузка урока...</div>;
    }

    return (
        <div className="lesson-description">
            <div className="lesson-description-text">
                <p><strong>Описание:</strong> {displayData.description}</p>
            </div>

            <div className="lesson-theme">
                <p><strong>Тема урока:</strong></p>
                <p>{displayData.theme}</p>
            </div>

            {displayData.homework && displayData.homework.tasks && displayData.homework.tasks.length > 0 && (
                <div className="lesson-homework">
                    <h3>Домашнее задание:</h3>
                    <ol>
                        {displayData.homework.tasks.map((task, index) => (
                            <li key={index}>{task.title}
                                {task.subtasks && task.subtasks.length > 0 && (
                                    <ul>
                                        {task.subtasks.map((subtask, idx) => (
                                            <li key={idx}>{subtask}</li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ol>
                </div>
            )}

            <LessonCardItem moduleName={moduleName} lessonId={lessonId} />

            {displayData.homework && displayData.homework.criteria && displayData.homework.criteria.length > 0 && (
                <div className="lesson-criteria">
                    <h3>Критерии проверки:</h3>
                    <ol>
                        {displayData.homework.criteria.map((criterion, index) => (
                            <li key={index}>{criterion}</li>
                        ))}
                    </ol>
                </div>
            )}

            {displayData.homework && displayData.homework.maxScore !== undefined && (
                <div className="lesson-max-score">
                    <h3>Максимальная оценка за задание:</h3>
                    <p>{displayData.homework.maxScore} баллов</p>
                </div>
            )}
        </div>
    );
};

export default LessonDescription; 